import { GenIcon } from '../helpers/IconBase.es.js';

const SaveOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 25 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.25 3.5C5.00736 3.5 4 4.50736 4 5.75V18.2506C4 19.4932 5.00736 20.5006 6.25 20.5006H18.7506C19.9932 20.5006 21.0006 19.4932 21.0006 18.2506V8.20357C21.0006 7.87205 20.8689 7.55411 20.6345 7.31969L17.1809 3.86612C16.9465 3.6317 16.6285 3.5 16.297 3.5H6.25ZM2.5 5.75C2.5 3.67893 4.17893 2 6.25 2H16.297C17.0264 2 17.7258 2.28973 18.2416 2.80546L21.6951 6.25903C22.2109 6.77475 22.5006 7.47423 22.5006 8.20357V18.2506C22.5006 20.3216 20.8217 22.0006 18.7506 22.0006H6.25C4.17893 22.0006 2.5 20.3217 2.5 18.2506V5.75ZM7.94943 12.75C7.81136 12.75 7.69943 12.8619 7.69943 13V17.5502C7.69943 17.9644 7.36365 18.3002 6.94943 18.3002C6.53522 18.3002 6.19943 17.9644 6.19943 17.5502V13C6.19943 12.0335 6.98294 11.25 7.94943 11.25H17.0498C18.0163 11.25 18.7998 12.0335 18.7998 13V17.5502C18.7998 17.9644 18.464 18.3002 18.0498 18.3002C17.6356 18.3002 17.2998 17.9644 17.2998 17.5502V13C17.2998 12.8619 17.1879 12.75 17.0498 12.75H7.94943ZM16.0253 6.44992C16.0253 6.03571 15.6895 5.69992 15.2753 5.69992C14.8611 5.69992 14.5253 6.03571 14.5253 6.44992V8.3007C14.5253 8.71492 14.8611 9.0507 15.2753 9.0507C15.6895 9.0507 16.0253 8.71492 16.0253 8.3007V6.44992Z",
          fill: "#9E9E9E"
        }
      }
    ]
  })(props);
};

export { SaveOutlined };
